<script setup lang="ts">
import { RouterLink } from 'vue-router';
import MylimniLogo from '@/components/MylimniLogo.vue';
</script>

<template>
  <div class="logo">
    <RouterLink
      to="/"
      aria-label="Mylimni home"
    >
      <MylimniLogo />
    </RouterLink>
  </div>
</template>
